module.exports = __webpack_public_path__ + "img/042.8fbd5629.png";